import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, IconButton, DialogContent, Typography, Autocomplete, TextField, DialogActions, Alert } from '@mui/material';
import { CloseSquare } from 'iconsax-react';
import { observer } from 'mobx-react';
//import styles from './view-card.module.scss';

const SyncModal =  observer(({ show, setShow, uiStore, cardId, setPending }) => {
    const { userCards, error, context } = uiStore
    const [cards, setCards] = useState([]);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const confirm = async () => {
        setLoading(true);
        const res = await uiStore.sendSyncRequest(cards.map(i => i.value), message, cardId);
        if (res) {
            setShow(false);
            setPending(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        if ((userCards.length === 0 || !userCards) && cardId){
            uiStore.fetchCards(cardId)
        }

    }, [show, uiStore, userCards, context?.authenticatedUser?.id, cardId])

    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Sync Request
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                {error && !error.includes('Private card') &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }

                <Typography>Choose cards to send sync request with</Typography>
                <Autocomplete
                    multiple
                    sx={{ mt: 3, mb: 3 }}
                    renderInput={(params) => <TextField label='Cards' {...params} />}
                    options={userCards?.map(i => ({ label: i.name, value: i._id }))|| []}
                    value={cards}
                    onChange={(e, value) => setCards(value)}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    filterSelectedOptions
                />
                <TextField
                    label='Message (Optional)'
                    fullWidth
                    multiline
                    rows={5}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                    Cancel
                </LoadingButton>
                <LoadingButton loading={loading} onClick={confirm} variant="contained" color="primary">
                    Send
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
});

export default SyncModal;